import {Nullish} from 'shared/web';

import {ParameterItem} from './ParameterItem';
import {ParameterTooltip} from './ParameterTooltip';

export type CustomParameter = ParameterItem & ParameterTooltip;

export type Parameter = string | CustomParameter | Nullish;
